export class CsvParser {
  static guessDelimiter = (content: string): ',' | ';' => {
    const commaCount = (content.match(/,/g) || []).length;
    const semicolonCount = (content.match(/;/g) || []).length;
    return semicolonCount > commaCount ? ';' : ',';
  };
}
